var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OddColumnHeader-styles-header"},_vm._l((_vm.label),function(l){return (_vm.label)?_c('div',{staticClass:"OddColumnHeader-styles-header-item notranslate"},[_vm._v("\n    "+_vm._s(l.outcome))]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19a7be9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/marketLabel.vue
// module id = y0cQ
// module chunks = 0